import type { ReactNode } from "react";

import { Center } from "@freightsimple/ui-core/PageLayout/Center";
import { Logo } from "@freightsimple/ui-core/Display/Logo";
import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";

import { BigCommerceConnectPageSurface } from "../CustomComponents/Internal/BigCommerceConnectPageSurface";

/**
 * Popup-sized card for the BigCommerce connect flow. Sized for the 520×680 popup, which the
 * standard authentication container overflows.
 */
export function BigCommerceConnectCard_({
  children,
  hideLogo = false,
}: {
  children: ReactNode;
  // The sign-in state brings its own logo; hide the card's to avoid two.
  hideLogo?: boolean;
}) {
  return (
    <BigCommerceConnectPageSurface>
      <Center minHeight="calc(100vh - 48px)" maxWidth={420}>
        <Panel>
          <Stack gap={6} align="center">
            {!hideLogo && <Logo />}
            {children}
          </Stack>
        </Panel>
      </Center>
    </BigCommerceConnectPageSurface>
  );
}

/** Centres a fixed-size spinner within the card's centred column. */
export function BigCommerceConnectSpinnerRow_({
  children,
}: {
  children: ReactNode;
}) {
  return <Row justify="center">{children}</Row>;
}
